import {
  CARD_MARGIN_Y,
  SUBCARD_MARGIN_Y,
} from "@packages/design-system/constants";

export default function HorizontalRule({ variant }: { variant?: "sub" }) {
  const subCard = variant === "sub";
  const marginY = subCard ? SUBCARD_MARGIN_Y : CARD_MARGIN_Y;

  return <hr className={`border-border-light mx-4 border-t-1 ${marginY}`} />;
}
